// action types
export const LESSONS = "[LESSONS]";
export const SET_LESSONS = "SET_LESSONS";
export const GET_LESSONS = "GET_LESSONS";
export const GET_LESSONS_ID = "GET_LESSONS_ID";

export const setLessons = (payload) => ({
  type: `${SET_LESSONS}`,
  payload
});

export const getLessons = (payload) => ({
  type: `${GET_LESSONS}`
});

export const getLessonsId = (videoId) => ({
  type: `${GET_LESSONS_ID}`,
  videoId
});



// WEBPACK FOOTER //
// ./src/redux/actions/lessonsActions.js